var _title, _desc, _defs, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgVehicleRegistration = function SvgVehicleRegistration(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "214px",
    height: "134px",
    viewBox: "0 0 214 134",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "8880FC5E-E1FC-4655-9F2C-B7F78E2015C7")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M55.9758721,14.1016949 L56.7084264,17.3583133 C56.8681836,18.0671956 56.3612207,18.7489868 55.6731996,18.7489868 L15.2887046,18.7489868 C14.5985535,18.7489868 14.0915905,18.0671956 14.2513478,17.3583133 L14.983902,14.1016949 L55.9758721,14.1016949 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02_Wallet_L_1440_Full",
    transform: "translate(-109.000000, -937.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vehicle-Registrations",
    transform: "translate(64.000000, 782.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Registered-Card",
    transform: "translate(0.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vehicle-Registration-Card",
    transform: "translate(45.000000, 83.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Card-BG",
    fill: "#304FFE",
    x: 0,
    y: 0,
    width: 214,
    height: 134,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,42 L179,42 C180.656854,42 182,43.3431458 182,45 C182,46.6568542 180.656854,48 179,48 L115,48 C113.343146,48 112,46.6568542 112,45 C112,43.3431458 113.343146,42 115,42 Z M115,64 L179,64 C180.656854,64 182,65.3431458 182,67 C182,68.6568542 180.656854,70 179,70 L115,70 C113.343146,70 112,68.6568542 112,67 C112,65.3431458 113.343146,64 115,64 Z M115,86 L179,86 C180.656854,86 182,87.3431458 182,89 C182,90.6568542 180.656854,92 179,92 L115,92 C113.343146,92 112,90.6568542 112,89 C112,87.3431458 113.343146,86 115,86 Z",
    id: "Lines",
    fill: "#243ACB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vehicle-Registration-Icon",
    transform: "translate(26.000000, 41.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.14924826,51.3145009 C7.07136047,51.3145009 6.19655299,50.4370621 6.19655299,49.3559322 L6.19655299,34.406177 C6.19655299,33.3250471 7.07136047,32.4476083 8.14924826,32.4476083 L14.86652,32.4476083 C15.9444078,32.4476083 16.8192153,33.3250471 16.8192153,34.406177 L16.8192153,49.3559322 C16.8192153,50.4370621 15.9444078,51.3145009 14.86652,51.3145009 L8.14924826,51.3145009 Z M55.9512285,51.263774 C54.8733407,51.263774 53.9985332,50.3863352 53.9985332,49.3052053 L53.9985332,34.3554501 C53.9985332,33.2743202 54.8733407,32.3968814 55.9512285,32.3968814 L62.6685002,32.3968814 C63.746388,32.3968814 64.6211955,33.2743202 64.6211955,34.3554501 L64.6211955,49.3052053 C64.6211955,50.3863352 63.746388,51.263774 62.6685002,51.263774 L55.9512285,51.263774 Z",
    id: "Combined-Shape",
    fill: "#1C2CA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.95347635,26.6631714 C0.873635864,26.6631714 0.000781078108,25.7876911 0.000781078108,24.7046026 L0.000781078108,21.6884068 C0.000781078108,20.6072768 0.873635864,19.729838 1.95347635,19.729838 L4.95867437,19.729838 C6.03851485,19.729838 6.91136964,20.6072768 6.91136964,21.6884068 L6.91136964,24.7046026 C6.91136964,25.7876911 6.03851485,26.6631714 4.95867437,26.6631714 L1.95347635,26.6631714 Z",
    id: "Fill-11",
    fill: "#1C2CA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0325385,26.6631714 C64.952698,26.6631714 64.0798432,25.7876911 64.0798432,24.7046026 L64.0798432,21.6884068 C64.0798432,20.6072768 64.952698,19.729838 66.0325385,19.729838 L69.0377365,19.729838 C70.117577,19.729838 70.9904318,20.6072768 70.9904318,21.6884068 L70.9904318,24.7046026 C70.9904318,25.7876911 70.117577,26.6631714 69.0377365,26.6631714 L66.0325385,26.6631714 Z",
    id: "Fill-12",
    fill: "#1C2CA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4837748,0.000979284369 L52.3355358,0.000979284369 C55.4299414,0.000979284369 58.1632847,2.01715537 59.0769499,4.97359951 L64.1500978,21.389325 C64.4629106,22.4015269 64.6219765,23.4549588 64.6219765,24.5143947 L64.6219765,37.0130847 C64.6219765,39.9357756 62.2526674,42.3050847 59.3299765,42.3050847 L11.4893341,42.3050847 C8.56664317,42.3050847 6.19733407,39.9357756 6.19733407,37.0130847 L6.19733407,24.5143947 C6.19733407,23.4549588 6.3564,22.4015269 6.66921284,21.389325 L11.7423607,4.97359951 C12.6560259,2.01715537 15.3893692,0.000979284369 18.4837748,0.000979284369 Z",
    id: "Combined-Shape",
    fill: "#243ACB"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10",
    fill: "#1C2CA2",
    fillRule: "nonzero",
    x: 21.7269894,
    y: 34.4919835,
    width: 27.3637697,
    height: 5.40723775,
    rx: 0.882
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.80815,32.0239699 C13.8747828,32.0239699 11.4968188,30.6428821 11.4968188,28.9392241 C11.4968188,27.2355661 13.8747828,25.8544783 16.80815,25.8544783 C19.7415172,25.8544783 22.1194811,27.2355661 22.1194811,28.9392241 C22.1194811,30.6428821 19.7415172,32.0239699 16.80815,32.0239699 Z M53.9874679,32.0239699 C51.0541007,32.0239699 48.6761368,30.6428821 48.6761368,28.9392241 C48.6761368,27.2355661 51.0541007,25.8544783 53.9874679,25.8544783 C56.9208351,25.8544783 59.298799,27.2355661 59.298799,28.9392241 C59.298799,30.6428821 56.9208351,32.0239699 53.9874679,32.0239699 Z",
    id: "Combined-Shape-Copy-2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.222604,6.3074256 C54.1075788,5.79721097 53.6794295,5.44051224 53.1873773,5.44051224 L17.774527,5.44051224 C17.2803446,5.44051224 16.8521953,5.79721097 16.7371701,6.3074256 L14.2513478,17.3583133 C14.0915905,18.0671956 14.5985535,18.7489868 15.2887046,18.7489868 L55.6731996,18.7489868 C56.3612207,18.7489868 56.8681836,18.0671956 56.7084264,17.3583133 L54.222604,6.3074256 Z",
    id: "Mask",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5873743,18.7489868 L17.8702714,18.7489868 C18.5955889,13.5750925 21.6146277,9.69491525 25.2288229,9.69491525 C28.8430181,9.69491525 31.8620569,13.5750925 32.5873743,18.7489868 Z",
    id: "Combined-Shape",
    fill: "#1C2CA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.947477,18.7489868 L38.2303741,18.7489868 C38.9556916,13.5750925 41.9747304,9.69491525 45.5889256,9.69491525 C49.2031207,9.69491525 52.2221595,13.5750925 52.947477,18.7489868 Z",
    id: "Combined-Shape",
    fill: "#1C2CA2"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#1C2CA2",
    xlinkHref: "#path-1"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVehicleRegistration, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vehicle-registration.0f0ecd9f.svg";
export { ForwardRef as ReactComponent };